/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import { extractErrorDetails } from '@/helpers/util.js';

const initialState = () => ({
  snackbar: {
    disabled: false,
    selector: false,
    init_filter: [],
    filter: [],
    show: false,
    hover: false,
    action: 'update',
    target_type: 'tworkpackages',
    target_id: 1,
    parent_type: 'twaggons',
    parent_id: 1,

    update: {},
    update_old_values: {},

    value_name: 'position',
    value_old: 0,
    value_new: 1,

    check_old_value: false,
    affected_targets: [],
    affected_parents: [],
    affected_new_parents: [],

    url: '',
    parent_cache: {},
    new_parent_cache: {},
    position_difference: 0,
    start_difference: 0,

    reference: false,
    affected_references: [],
    u_object: {},
    bulk_bulk: false
  }

});

// State object
const state = initialState();
// Getter functions
const getters = {
  getAffectedTargets: (state, getters, rootState) => {
    if (state.snackbar.target_type === 'tworkpackages' && state.snackbar.check_old_value && state.snackbar.value_name !== 'position') {
      return state.snackbar.affected_targets.filter(target_id => {
        let target = rootState.Ultra[state.snackbar.target_type][target_id];
        return target[state.snackbar.value_name] === state.snackbar.value_old;
      });
    }
    else {
      return state.snackbar.affected_targets;
    }
  },
  getAffectedIdsSelector: (state, getters, rootState) => {
    if (state.snackbar[state.snackbar.selector.select_key + '_type'] === 'tworkpackages' && state.snackbar.check_old_value && state.snackbar.value_name !== 'position') {
      return state.snackbar['affected_' + state.snackbar.selector.select_key + 's'].filter(target_id => {
        let target = rootState.Ultra[state.snackbar[state.snackbar.selector.select_key + '_type']][target_id];
        return target[state.snackbar.value_name] === state.snackbar.value_old;
      });
    }
    else {
      return state.snackbar['affected_' + state.snackbar.selector.select_key + 's'];
    }
  }
};
// Actions
const actions = {
  applySnackbar({ state, getters, rootState, dispatch, commit }) {
    if (state.snackbar.action === 'create') {
      let ultra_payload = {
        url: '',
        bulk: {
          targets: { [state.snackbar.target_type]: [] },
          parents: { [state.snackbar.parent_type]: state.snackbar.affected_parents },
        }
      };
      ultra_payload.url = JSON.parse(JSON.stringify(state.snackbar.url));
      if (state.snackbar.url.length === 6 && Object.keys(state.snackbar.url[4])[0] === 'extendwp') {
        ultra_payload.url.splice(3, 1, { twaggons: '0' });
        ultra_payload.url.splice(4, 1, { extendwpbulk: '' });
      } else {
        ultra_payload.url.splice(state.snackbar.url.length - 1, 0, { createbulk: '' });
      }

      state.snackbar.affected_parents.forEach((parent_id, index) => {
        if (state.snackbar.reference) {
          let position = rootState.Ultra[state.snackbar.parent_type][parent_id][state.snackbar.reference.type].indexOf(state.snackbar.affected_references[index]) + parseInt(1);
          if (!state.snackbar.reference.before) {
            position++;
          }
          let u_object = JSON.parse(JSON.stringify(state.snackbar.u_object));
          ultra_payload.bulk.targets[state.snackbar.target_type].push(Object.assign(u_object, { position: position }));
        } else {
          ultra_payload.bulk.targets[state.snackbar.target_type].push(state.snackbar.u_object);
        }

      });
      if (state.snackbar.bulk_bulk) {
        let copy_parents = JSON.parse(JSON.stringify(ultra_payload.bulk.parents[state.snackbar.parent_type])); //
        let copy_targets = JSON.parse(JSON.stringify(ultra_payload.bulk.targets[state.snackbar.target_type])); //

        for (var i = 1; i < state.snackbar.bulk_bulk.amount; i++) {
          for (var j = 0; j < copy_parents.length; j++) {
            ultra_payload.bulk.parents[state.snackbar.parent_type].push(copy_parents[j]);
            // Todo: hard coded for Waggons
            ultra_payload.bulk.targets[state.snackbar.target_type].push({
              position: copy_targets[j].position + i,
              token: copy_targets[j].token,
              tworkpackages: copy_targets[j].tworkpackages
            });
          }
        }
      }
      dispatch('Ultra/createUObject', ultra_payload, { root: true }).then(() => {
        dispatch('ProjectCalendar/updateCalenderLookup', state.snackbar.url[0].projects, { root: true });
      });
    }
    else if (state.snackbar.action === 'update') {
      let targets = getters.getAffectedTargets;
      let ultra_payload = {
        url: '',
        bulk: {
          targets: { [state.snackbar.target_type]: targets },
          updates: []
        }
      };
      ultra_payload.url = JSON.parse(JSON.stringify(state.snackbar.url));
      ultra_payload.url[ultra_payload.url.length - 1][state.snackbar.target_type] = 0;
      ultra_payload.url.push({ updatebulk: '' });

      targets.forEach(() => {
        ultra_payload.bulk.updates.push(state.snackbar.update);
      });
      dispatch('Ultra/updateUObject', ultra_payload, { root: true }).then(() => {
        dispatch('ProjectCalendar/updateCalenderLookup', state.snackbar.url[0].projects, { root: true });
      });
    }
    else if (state.snackbar.action === 'updateparent') {
      let targets = state.snackbar.affected_targets;
      let ultra_payload = {
        url: '',
        bulk: {
          targets: [],
          parents: state.snackbar.affected_new_parents,
          old_parents: state.snackbar.affected_parents
        }
      };
      ultra_payload.url = JSON.parse(JSON.stringify(state.snackbar.url));
      ultra_payload.url[ultra_payload.url.length - 2][state.snackbar.target_type] = 0;
      ultra_payload.url.splice(ultra_payload.url.length - 1, 1, { updateparentbulk: '' });

      targets.forEach((target_id) => {
        ultra_payload.bulk.targets.push({
          id: target_id,
          position: state.snackbar.update.position
        });
      });
      dispatch('Ultra/updateUObjectParent', ultra_payload, { root: true });
    }
    else if (state.snackbar.action === 'updateposition') {
      let targets = state.snackbar.affected_targets;
      let ultra_payload = {
        url: '',
        bulk: {
          targets: { [state.snackbar.target_type]: targets },
          parents: { [state.snackbar.parent_type]: state.snackbar.affected_parents },
          updates: []
        }
      };
      ultra_payload.url = JSON.parse(JSON.stringify(state.snackbar.url));
      ultra_payload.url[ultra_payload.url.length - 1][state.snackbar.target_type] = 0;
      ultra_payload.url.push({ updatebulk: '' });

      targets.forEach(() => {
        ultra_payload.bulk.updates.push({
          position: state.snackbar.position_difference,
          // position_update: state.snackbar.position_difference
        });
      });
      dispatch('Ultra/updateUObjectPosition', ultra_payload, { root: true }).then(() => {
        dispatch('ProjectCalendar/updateCalenderLookup', state.snackbar.url[0].projects, { root: true });
      });
    }
    else if (state.snackbar.action === 'updatetaktareastart') {
      let targets = state.snackbar.affected_targets;
      let ultra_payload = {
        url: '',
        bulk: {
          targets: { [state.snackbar.target_type]: targets },
          updates: []
        }
      };
      ultra_payload.url = JSON.parse(JSON.stringify(state.snackbar.url));
      ultra_payload.url[ultra_payload.url.length - 1][state.snackbar.target_type] = 0;
      ultra_payload.url.push({ updatebulk: '' });

      targets.forEach((target_id) => {
        let taktarea_start = rootState.Ultra[state.snackbar.target_type][target_id].taktarea_start + parseInt(state.snackbar.start_difference);
        if (taktarea_start < 0) {
          taktarea_start = 0;
        }
        ultra_payload.bulk.updates.push({
          taktarea_start: taktarea_start
        });
      });
      dispatch('Ultra/updateUObject', ultra_payload, { root: true }).then(() => {
        dispatch('ProjectCalendar/updateCalenderLookup', ultra_payload.url[0].projects, { root: true });
      });
    }
    else if (state.snackbar.action === 'delete') {
      let ultra_payload = {
        url: '',
        bulk: {
          targets: { [state.snackbar.target_type]: state.snackbar.affected_targets },
          parents: { [state.snackbar.parent_type]: state.snackbar.affected_parents },
        }
      };
      ultra_payload.url = JSON.parse(JSON.stringify(state.snackbar.url));
      ultra_payload.url[ultra_payload.url.length - 1][state.snackbar.target_type] = 0;
      ultra_payload.url.push({ deletebulk: '' });
      dispatch('Ultra/deleteUObject', ultra_payload, { root: true }).then(() => {
        dispatch('ProjectCalendar/updateCalenderLookup', state.snackbar.url[0].projects, { root: true });
      });
    }
    commit('update_snackbar', { show: false, hover: false, selector: false});

  },
  applySnackbarCreateElements({ state, dispatch, commit }) {
    // response_elements = target ids = workstep ids
    // affected_additional_targets.ids = additional targets = taktarea ids
    // e_object = element payload

    let project_id = state.snackbar.url[0].projects;

    let ultra_payload = {
      url: [
        { elements: 'createbulk' },
        { showWithEntitiesNormalized: '' }
      ],
      url_prefix: `/projects/${project_id}/projectstructure`,
      call_only: true,
      u_object: {
        elements: [],
        updates: []
      }
    };
    // iterate over each reference (=workstep id)

    let iterator = 0;
    if (state.snackbar.bulk_bulk) {
      iterator = state.snackbar.bulk_bulk.amount;
    }

    for (let index = 0; index < state.snackbar.affected_references.length; index++) {
      for(let i = 0; i < iterator; i++){
        let el_payload = JSON.parse(JSON.stringify(state.snackbar.e_object));
        // reset taktareas and tworksteps ID
        const workstep_id = state.snackbar.affected_references[index];
        el_payload['add#tworksteps'] = [workstep_id];
        const taktarea_id = state.snackbar.affected_additional_targets.ids[index];
        el_payload['add#taktareas'] = [taktarea_id];
        // TODO: In the future different parents in some cases... 
        ultra_payload.u_object.elements.push(el_payload);
      }
    }
    dispatch('Ultra/createUObject', ultra_payload, { root: true });
    commit('update_snackbar', { show: false, hover: false, affected_additional_targets: false });
  },
  applySnackbarUpdateElements({ state, dispatch, commit }) {
    // response_elements = element ids
    let project_id = state.snackbar.project_id;
    let ultra_payload = {
      url: [
        { elements: '0' },
        { updatebulk: '' }
      ],
      url_prefix: `/projects/${project_id}/projectstructure`,
      call_only: true,
      update: {
        elements: [],
        updates: []
      }
    };
    // iterate over each element
    for (let index = 0; index < state.snackbar.response_elements.length; index++) {
      let el_uppdate = JSON.parse(JSON.stringify(state.snackbar.update));
      ultra_payload.update.elements.push(state.snackbar.response_elements[index]);
      ultra_payload.update.updates.push(el_uppdate);
    }
    dispatch('Ultra/updateUObject', ultra_payload, { root: true }).then(() => {
      dispatch('Ultra/requestUObject', {
        url: [
          {projects: 0},
          {trains: 0},
          {taktareas: 0},
          {twaggons: 0},
          {tworkpackages: 0},
          {tworksteps: state.snackbar.tworkstep_id},
          {showWithEntitiesNormalized: ''}
        ]
      }, { root: true });
    });
    commit('update_snackbar', { show: false, hover: false, bim_process: false, response_elements: false });
  },
  requestSnackbar() {
    return new Promise((resolve) => {
      resolve();
    });
  },
  requestSnackbarCreate({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {

      if (rootState.SnackBar.snackbar.disabled) {
        resolve(payload);
      } else {

        let exceptions = ['extendwp'];
        let modifier = 0;
        if (exceptions.includes(Object.keys(payload.url[payload.url.length - 2])[0])) {
          modifier++;
        }
        let target_type = Object.keys(payload.url[payload.url.length - (2 + modifier)])[0];
        let target_id = Object.values(payload.url[payload.url.length - (2 + modifier)])[0];
        let parent_type = Object.keys(payload.url[payload.url.length - (3 + modifier)])[0];
        let parent_id = Object.values(payload.url[payload.url.length - (3 + modifier)])[0];
        let parent_cache = JSON.parse(JSON.stringify(rootState.Ultra[parent_type][parent_id]));
  
        let reference = false;
        let additional_target_entity = false;
        if (payload.reference) {
          reference = payload.reference;
          if (reference.additional_target_entity) {
            additional_target_entity = reference.additional_target_entity;
          }
        }
        axios({
          url: 'projects/' + payload.url[0].projects + '/snackbar',
          method: 'POST',
          data: {
            target_entity: reference ? reference.type : parent_type,
            id: reference ? reference.id : parent_id,
            additional_target_entity: additional_target_entity,
            wp_part: true
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
          .then(resp => {
            let affected_references = [];
            let affected_parents = [];
            let affected_additional_targets = [];
            let e_object = false;
            if (reference) {
              affected_references = resp.data.data.targets.ids;
              affected_parents = resp.data.data.parents.ids;
              if (additional_target_entity) {
                affected_additional_targets = resp.data.data.additional_target_entity;
                e_object = payload.e_object;
              }
  
            } else {
              affected_parents = resp.data.data.targets.ids;
            }
            let selector = false;
            if (payload.selector){
              selector = {
                select_key: payload.selector,
                init_affected_targets: [],
                init_affected_parents: JSON.parse(JSON.stringify(affected_parents)),
                init_affected_references: JSON.parse(JSON.stringify(affected_references))
              }
              if (payload.limit_selector) {
                switch (selector.select_key) {
                  case 'parent':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_parents))})
                    break;
                  case 'target':
                    break;
                  case 'reference':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_references)), reference_id: payload.reference.id, reference_type: payload.reference.type})
                    break;
                }
              }
            }
            let snackbar_payload = {
              selector: selector,
              show: true,
              action: 'create',
              target_type: target_type,
              target_id: target_id,
              parent_type: parent_type,
              parent_id: parent_id,
              parent_cache: parent_cache,
              reference_id: selector.reference_id,
              reference_type: selector.reference_type,
              u_object: payload.u_object,
              reference: reference,
              affected_references: affected_references,
              affected_parents: affected_parents,
              affected_additional_targets: affected_additional_targets,
              e_object: e_object,
              url: payload.url,
              bim_process: false,
              init_filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : [],
              filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : []
            };
            if (payload.is_elements) {
              snackbar_payload.is_elements = true;
            }
  
            if (payload.bulk_bulk) {
              snackbar_payload.bulk_bulk = payload.bulk_bulk;
            } else {
              snackbar_payload.bulk_bulk = false;
            }
  
          if (
            (snackbar_payload.action === 'create' && snackbar_payload.affected_parents.length > 0) ||
            (snackbar_payload.action !== 'create' && snackbar_payload.affected_targets.length > 0)
          ) {
            commit('update_snackbar', snackbar_payload);
          }
          resolve(payload);
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
      }

    });
  },
  requestSnackbarUpdate({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {

      if (rootState.SnackBar.snackbar.disabled) {
        resolve(payload);
      } else {

        let target_type = Object.keys(payload.url[payload.url.length - 1])[0];
        let target_id = Object.values(payload.url[payload.url.length - 1])[0];
        let parent_type = Object.keys(payload.url[payload.url.length - 2])[0];
        let parent_id = Object.values(payload.url[payload.url.length - 2])[0];
        let value_name = Object.keys(payload.update)[0];
        let value_old = rootState.Ultra[target_type][target_id][value_name];
        let value_new = Object.values(payload.update)[0];
  
        let update_old_values = {};
        for (let prop in payload.update) {
          update_old_values[prop] = rootState.Ultra[target_type][target_id][prop];
        }
  
  
        axios({
          url: 'projects/' + payload.url[0].projects + '/snackbar',
          method: 'POST',
          data: {
            target_entity: target_type,
            id: target_id,
            wp_part: true
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
          .then(resp => {
            let affected_targets = resp.data.data.targets.ids;
            let affected_parents = resp.data.data.parents.ids;
            let selector = false;
            if (payload.selector){
              selector = {
                select_key: payload.selector,
                init_affected_targets: JSON.parse(JSON.stringify(affected_targets)),
                init_affected_parents: JSON.parse(JSON.stringify(affected_parents))
              }
              if (payload.limit_selector) {
                switch (selector.select_key) {
                  case 'parent':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_parents))})
                    break;
                  case 'target':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_targets))})
                    break;
                  case 'reference':
                    break;
                }
              }
            }
            let snackbar_payload = {
              selector: selector,
              show: true,
              action: 'update',
              target_type: target_type,
              target_id: target_id,
              parent_type: parent_type,
              parent_id: parent_id,
  
              update: payload.update,
              update_old_values: update_old_values,
              value_name: value_name,
              value_old: value_old,
              value_new: value_new,
  
              affected_targets: affected_targets,
              affected_parents: affected_parents,
              url: payload.url,
              bim_process: false,
              init_filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : [],
              filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : []
            };
            if (
              (snackbar_payload.action === 'create' && snackbar_payload.affected_parents.length > 0) ||
              (snackbar_payload.action !== 'create' && snackbar_payload.affected_targets.length > 0)
            ) {
              commit('update_snackbar', snackbar_payload);
            }
            resolve(payload);
          })
          .catch(err => {
            commit('set_error', extractErrorDetails(err));
            commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
            reject();
          });
      }

    });
  },
  requestSnackbarUpdateTaktareaStart({ commit, rootState }, payload) {
    return new Promise((resolve) => {

      if (rootState.SnackBar.snackbar.disabled) {
        resolve(payload);
      } else {
        let target_type = Object.keys(payload.url[payload.url.length - 1])[0];
        let target_id = Object.values(payload.url[payload.url.length - 1])[0];
        let parent_type = Object.keys(payload.url[payload.url.length - 2])[0];
        let parent_id = Object.values(payload.url[payload.url.length - 2])[0];
        let value_name = Object.keys(payload.update)[0];
        let value_old = rootState.Ultra[target_type][target_id][value_name];
        let value_new = Object.values(payload.update)[0];
  
        let start_difference = value_new - value_old;
  
        let parent = rootState.Ultra[parent_type][parent_id];
        let index = parent[target_type].indexOf(target_id);
  
        let affected_targets = parent[target_type].slice(index + parseInt(1));
        let snackbar_payload = {
          show: true,
          action: 'updatetaktareastart',
          target_type: target_type,
          target_id: target_id,
          parent_type: parent_type,
          parent_id: parent_id,
  
          update: payload.update,
          value_name: value_name,
          value_old: value_old,
          value_new: value_new,
          start_difference: start_difference,
  
          affected_targets: affected_targets,
          url: payload.url,
          bim_process: false
        };
        if (
          (snackbar_payload.action === 'create' && snackbar_payload.affected_parents.length > 0) ||
          (snackbar_payload.action !== 'create' && snackbar_payload.affected_targets.length > 0)
        ) {
          commit('update_snackbar', snackbar_payload);
        }
        resolve(payload);
      }

    });
  },
  requestSnackbarUpdatePosition({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {

      if (rootState.SnackBar.snackbar.disabled) {
        resolve(payload);
      } else {

        let target_type = Object.keys(payload.url[payload.url.length - 1])[0];
        let target_id = Object.values(payload.url[payload.url.length - 1])[0];
        let parent_type = Object.keys(payload.url[payload.url.length - 2])[0];
        let parent_id = Object.values(payload.url[payload.url.length - 2])[0];
  
        let value_name = Object.keys(payload.update)[0];
        let position_difference = Object.values(payload.update)[0];
  
        let value_old = rootState.Ultra[parent_type][parent_id][target_type].indexOf(target_id) + parseInt(1);
        let value_new = value_old + position_difference;
  
  
        axios({
          url: 'projects/' + payload.url[0].projects + '/snackbar',
          method: 'POST',
          data: {
            target_entity: target_type,
            id: target_id,
            wp_part: true
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
          .then(resp => {
            let affected_targets = resp.data.data.targets.ids;
            let affected_parents = resp.data.data.parents.ids;
            let selector = false;
            if (payload.selector){
              selector = {
                select_key: payload.selector,
                init_affected_targets: JSON.parse(JSON.stringify(affected_targets)),
                init_affected_parents: JSON.parse(JSON.stringify(affected_parents))
              }
              if (payload.limit_selector) {
                switch (selector.select_key) {
                  case 'parent':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_parents))})
                    break;
                  case 'target':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_targets))})
                    break;
                  case 'reference':
                    console.log('test')
                    break;
                }
              }
            }
            let snackbar_payload = {
              selector: selector,
              show: true,
              action: 'updateposition',
              target_type: target_type,
              target_id: target_id,
              parent_type: parent_type,
              parent_id: parent_id,
              value_name: value_name,
              value_old: value_old,
              value_new: value_new,
              affected_targets: affected_targets,
              affected_parents: affected_parents,
              url: payload.url,
              position_difference: position_difference,
              bim_process: false,
              init_filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : [],
              filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : []
            };
            if (
              (snackbar_payload.action === 'create' && snackbar_payload.affected_parents.length > 0) ||
              (snackbar_payload.action !== 'create' && snackbar_payload.affected_targets.length > 0)
            ) {
              commit('update_snackbar', snackbar_payload);
            }
            resolve(payload);
          })
          .catch(err => {
            commit('set_error', extractErrorDetails(err));
            commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
            reject();
          });
      }

    });
  },
  requestSnackbarUpdateParent({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {

      if (rootState.SnackBar.snackbar.disabled) {
        resolve(payload);
      } else {

        let target_type = Object.keys(payload.url[payload.url.length - 2])[0];
        let target_id = Object.values(payload.url[payload.url.length - 2])[0];
        let parent_type = Object.keys(payload.url[payload.url.length - 3])[0];
        let parent_id = Object.values(payload.url[payload.url.length - 3])[0];
  
        let parent_cache = JSON.parse(JSON.stringify(rootState.Ultra[parent_type][parent_id]));
        let new_parent_cache = JSON.parse(JSON.stringify(rootState.Ultra[parent_type][payload.update.parent_id]));
  
        axios({
          url: 'projects/' + payload.url[0].projects + '/snackbarchangeparent',
          method: 'POST',
          data: {
            target_entity: target_type,
            target_id: target_id,
            parent_id: payload.update.parent_id,
            wp_part: true
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
          .then(resp => {
            let affected_targets = resp.data.data.targets.targets.ids;
            let affected_parents = resp.data.data.targets.parents.ids;
            let affected_new_parents = resp.data.data.parents.targets.ids;
            let selector = false;
            if (payload.selector){
              selector = {
                select_key: payload.selector,
                init_affected_targets: JSON.parse(JSON.stringify(affected_targets)),
                init_affected_parents: JSON.parse(JSON.stringify(affected_parents))
              }
              if (payload.limit_selector) {
                switch (selector.select_key) {
                  case 'parent':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_parents))})
                    break;
                  case 'target':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_targets))})
                    break;
                  case 'reference':
                    console.log('test')
                    break;
                }
              }
            }
            let snackbar_payload = {
              selector: selector,
              show: true,
              action: 'updateparent',
              target_type: target_type,
              target_id: target_id,
              parent_type: parent_type,
              parent_id: parent_id,
  
              update: payload.update,
              parent_cache: parent_cache,
              new_parent_cache: new_parent_cache,
  
              affected_targets: affected_targets,
              affected_parents: affected_parents,
              affected_new_parents: affected_new_parents,
              url: payload.url,
              bim_process: false,
              init_filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : [],
              filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : []
            };
            if (
              (snackbar_payload.action === 'create' && snackbar_payload.affected_parents.length > 0) ||
              (snackbar_payload.action !== 'create' && snackbar_payload.affected_targets.length > 0)
            ) {
              commit('update_snackbar', snackbar_payload);
            }
            resolve(payload);
          })
          .catch(err => {
            commit('set_error', extractErrorDetails(err));
            commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
            reject();
          });
      }

    });
  },
  requestSnackbarDelete({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {

      if (rootState.SnackBar.snackbar.disabled) {
        resolve(payload);
      } else {

        let target_type = Object.keys(payload.url[payload.url.length - 1])[0];
        let target_id = Object.values(payload.url[payload.url.length - 1])[0];
        let parent_type = Object.keys(payload.url[payload.url.length - 2])[0];
        let parent_id = Object.values(payload.url[payload.url.length - 2])[0];
  
        let target_cache = JSON.parse(JSON.stringify(rootState.Ultra[target_type][target_id]));
        let parent_cache = JSON.parse(JSON.stringify(rootState.Ultra[parent_type][parent_id]));
        parent_cache[target_type] = JSON.parse(JSON.stringify(parent_cache[target_type].map(id => rootState.Ultra[target_type][id])));
  
        axios({
          url: 'projects/' + payload.url[0].projects + '/snackbar',
          method: 'POST',
          data: {
            target_entity: target_type,
            id: target_id,
            wp_part: true
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
          .then(resp => {
            let affected_targets = resp.data.data.targets.ids;
            let affected_parents = resp.data.data.parents.ids;
            let selector = false;
            if (payload.selector){
              selector = {
                select_key: payload.selector,
                init_affected_targets: JSON.parse(JSON.stringify(affected_targets)),
                init_affected_parents: JSON.parse(JSON.stringify(affected_parents))
              }
              if (payload.limit_selector) {
                switch (selector.select_key) {
                  case 'parent':
                    Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_parents))})
                    break;
                  case 'target':
                    break;
                  case 'reference':
                    break;
                }
              }
            }
            let snackbar_payload = {
              selector: selector,
              show: true,
              action: 'delete',
              target_type: target_type,
              target_id: target_id,
              parent_type: parent_type,
              parent_id: parent_id,
              affected_targets: affected_targets,
              affected_parents: affected_parents,
              url: payload.url,
              parent_cache: parent_cache,
              target_cache: target_cache,
              bim_process: false,
              init_filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : [],
              filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : []
            };
            if (
              (snackbar_payload.action === 'create' && snackbar_payload.affected_parents.length > 0) ||
              (snackbar_payload.action !== 'create' && snackbar_payload.affected_targets.length > 0)
            ) {
              commit('update_snackbar', snackbar_payload);
            }
            resolve(payload);
          })
          .catch(err => {
            commit('set_error', extractErrorDetails(err));
            commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
            reject();
          });
      }

    });
  },
  requestSnackbarBIMProcess({ commit, state }, payload) {
    return new Promise((resolve) => {

      if (state.snackbar.disabled) {
        resolve(payload);
      } else {
        axios({
          url: 'projects/' + payload.project_id + '/snackbarbimprocess',
          method: 'POST',
          data: {
            tworkstep: payload.tworkstep,
            conditions: payload.conditions
          },
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
          .then(resp => {
            let response_elements = [];
            resp.data.data.taktareas.forEach(ta => {
              response_elements = response_elements.concat(ta.elements);
            });
            let snackbar_payload = {
              show: true,
              action: payload.action,
              response: resp.data.data,
              response_elements: response_elements,
              project_id: payload.project_id,
              tworkstep_id: payload.tworkstep,
              conditions: payload.conditions,
              bim_process: true,
              update: payload.update,
              init_filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : [],
              filter: resp.data.data.filter ? JSON.parse(JSON.stringify(resp.data.data.filter)) : []
            };
            commit('update_snackbar', snackbar_payload);
            resolve();
          });
      }
    });
  },
  requestSnackbarFiltered({ state, commit }, payload) {
    // console.log("Begin RequestFiltered:", state.snackbar['selector'], payload.snackbar)
    let data = {
        target_entity: state.snackbar.target_type,
        id: state.snackbar.target_id,
        wp_part: true,
        filter: state.snackbar.filter
    }
    if (state.snackbar.action == 'create') {
      data.target_entity = state.snackbar.parent_type
      data.id = state.snackbar.parent_id
    }
    axios({
      url: 'projects/' + payload.project_id + '/snackbar',
      method: 'POST',
      data: data,
      headers: {
        'Cache-Control': 'no-cache'
      }
    }).then((resp) => {
        let affected_targets = resp.data.data.targets.ids;
        let affected_parents = resp.data.data.parents.ids;
        if (state.snackbar.action == 'create') {
          affected_parents = resp.data.data.targets.ids
          affected_targets = []
        }
        let selector = false;
        if (state.snackbar.selector){
          selector = {
            select_key: state.snackbar.selector.select_key,
            init_affected_targets: JSON.parse(JSON.stringify(affected_targets)),
            init_affected_parents: JSON.parse(JSON.stringify(affected_parents))
          }
          if (state.limit_selector) {
            switch (selector.select_key) {
              case 'parent':
                Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_parents))})
                break;
              case 'target':
                Object.assign(selector, {select_list: JSON.parse(JSON.stringify(affected_targets))})
                break;
              case 'reference':
                console.log('test')
                break;
            }
          }
        }
        let to_update = {
          affected_targets: affected_targets,
          affected_parents: affected_parents,
          selector: selector,
        }
        // console.log("Befor update request", state.snackbar, to_update)
        commit('update_snackbar', to_update);
        // console.log("After update request", state.snackbar, to_update)
    })
  },
  updateSnackbarFiltered({state, commit}, filter_prop) {
    // console.log("dsafsdf", state.snackbar)
    if (state.snackbar.filter.includes(filter_prop)) {
      let filter = JSON.parse(JSON.stringify(state.snackbar.filter))
      filter.splice(filter.indexOf(filter_prop), 1)
      commit('update_snackbar', {filter});
    }
    else {
      let filter = JSON.parse(JSON.stringify(state.snackbar.filter))
      filter.push(filter_prop)
      commit('update_snackbar', {filter});
    }
    
  },
  updateSnackbar({ commit }, payload) {
    commit('update_snackbar', payload);
  },
  editAffectedTargets({state, commit}, payload) {
    if (state.snackbar.affected_targets.includes(payload.workpackage_id)) {
      commit('remove_target', payload.workpackage_id);
    } else {
      commit('add_target', {target_id: payload.workpackage_id, parent_id: payload.waggon_id});
    }
  },
  editParentTargets({state, commit}, workpackage_id) {
    if (state.snackbar.affected_parents.includes(workpackage_id)) {
      commit('remove_parent', workpackage_id);
    } else {
      commit('add_parent', workpackage_id);
    }
  },
  editAffectedReferences({state, commit}, waggon_id) {
    if (state.snackbar.affected_references.includes(waggon_id)) {
      commit('remove_reference', waggon_id);
    } else {
      commit('add_reference', waggon_id);
    }
  },
  editSelector({state, commit, rootState}, affected_id) {
    // limited selectables
    if (!state.snackbar.selector.select_list || (state.snackbar.selector.select_list && state.snackbar.selector.select_list.includes(affected_id))) {
      // remove affected_id
      let index = state.snackbar['affected_' + state.snackbar.selector.select_key + 's'].indexOf(affected_id)
      if (index != -1) {
        switch(state.snackbar.selector.select_key) {
          case 'parent':
            commit('remove_parent', index);
            if(state.snackbar.affected_targets[index]){
              commit('remove_target', index);
            }
            // state.snackbar.affected_targets.filter( target_id => 
            //   rootState.Ultra[state.snackbar.parent_type][affected_id][state.snackbar.target_type].includes(target_id)
            // ).forEach(id => {
            //   commit('remove_target', id);
            // });
            break;
          case 'target':
            commit('remove_target', index);
            if (state.snackbar.affected_parents[index]){
              commit('remove_parent', index);
            }
            // if (
            //   state.snackbar.affected_targets.filter( target_id => 
            //     rootState.Ultra[state.snackbar.parent_type][Object.values(rootState.Ultra[state.snackbar.parent_type]).find(parent => 
            //       rootState.Ultra[state.snackbar.parent_type][parent.id][state.snackbar.target_type].includes(affected_id)
            //     ).id][state.snackbar.target_type].includes(target_id)
            //   ).length == 0
            // ) {
            //   commit('remove_parent', Object.values(rootState.Ultra[state.snackbar.parent_type]).find(parent => 
            //     rootState.Ultra[state.snackbar.parent_type][parent.id][state.snackbar.target_type].includes(affected_id)
            //   ).id)
            // }
            break;
          case 'reference':
            commit('remove_reference', index);
            if (state.snackbar.affected_parents[index]){
              commit('remove_parent', index);
            }
            break;
        }
      } 
      // add affected_id
      else {

        let index = state.snackbar.selector['init_affected_' + state.snackbar.selector.select_key + 's'].indexOf(affected_id);
        switch(state.snackbar.selector.select_key) {
          case 'parent':
            if(index != -1){
              commit('add_target', state.snackbar.selector.init_affected_targets[index]);
              commit('add_parent', affected_id);
            } else if (state.snackbar.selector.init_affected_targets.length > 0) {
              state.snackbar.selector.init_affected_targets.filter( target_id => 
                rootState.Ultra[state.snackbar.parent_type][affected_id][state.snackbar.target_type].includes(target_id)
              ).forEach(id => {
                commit('add_target', id);
                commit('add_parent', affected_id);
              });
            } else {
              commit('add_parent', affected_id);
            }
            break;
          case 'target':
            if (index != -1) {
              commit('add_target', affected_id);
              commit('add_parent', state.snackbar.selector.init_affected_parents[index]);
            } else if (state.snackbar.selector.init_affected_parents.length > 0) {
              commit('add_parent', Object.values(rootState.Ultra[state.snackbar.parent_type]).find(parent => 
                rootState.Ultra[state.snackbar.parent_type][parent.id][state.snackbar.target_type].includes(affected_id)
              ).id)
              commit('add_target', affected_id);
            } else {
              commit('add_target', affected_id);
            }
            break;
          case 'reference':
            if (index != -1 && state.snackbar.selector.init_affected_parents[index]) {
              commit('add_reference', affected_id);
              commit('add_parent', state.snackbar.selector.init_affected_parents[index]);
            } else if (state.snackbar.selector.init_affected_parents.length > 0) {
              commit('add_parent', Object.values(rootState.Ultra[state.snackbar.parent_type]).find(parent => 
                rootState.Ultra[state.snackbar.parent_type][parent.id][state.snackbar.reference_type].includes(affected_id)
              ).id)
              commit('add_reference', affected_id);
            } else {
              commit('add_reference', affected_id);
            }
            break;
        }
      }
    }
  }
};
// Mutations
const mutations = {
  update_snackbar(state, snackbar_payload) {
    // console.log("Befor update: ", state.snackbar, snackbar_payload['selector'], snackbar_payload)
    Object.assign(state.snackbar, snackbar_payload);
    // console.log("After update: ", state.snackbar['selector'], state.snackbar)
  },
  remove_target(state, index) {
    state.snackbar.affected_targets.splice(index, 1);
  },
  add_target(state, id) {
    state.snackbar.affected_targets.push(id);
  },
  remove_parent(state, index) {
    state.snackbar.affected_parents.splice(index, 1);
  },
  add_parent(state, id) {
    state.snackbar.affected_parents.push(id);
  },
  remove_reference(state, index) {
    state.snackbar.affected_references.splice(index, 1);
  },
  add_reference(state, id) {
    state.snackbar.affected_references.push(id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
